module.exports = __webpack_public_path__ + "img/logo.a40a6094.png";